import type { RouteObject } from "react-router-dom";
import NotFound from "@/pages/NotFound";
import Home from "@/pages/home/page";
import ArticlePage from "@/pages/article/page";
import BeginnersArticlePage from "@/pages/article/beginners/page";
import SafetyArticlePage from "@/pages/article/safety/page";

const routes: RouteObject[] = [
  {
    path: "/",
    element: <Home />,
  },
  {
    path: "/superbuy-spreadsheet-complete-guide",
    element: <ArticlePage />,
  },
  {
    path: "/superbuy-spreadsheet-beginners",
    element: <BeginnersArticlePage />,
  },
  {
    path: "/superbuy-spreadsheet-safety",
    element: <SafetyArticlePage />,
  },
  {
    path: "*",
    element: <NotFound />,
  },
];

export default routes;